import stages from '../../constants/stages';
import { SubmitPreProcessingContract } from '../stage-contracts';
import getStateDifference from '../get-state-difference';

const handleMergeResult = (currentFlowData, result) => {
  if (!result) return currentFlowData;

  if (!SubmitPreProcessingContract.isValid(result)) {
    // eslint-disable-next-line no-console
    console.warn(
      `${String(stages.SUBMIT_PRE_PROCESSING)} stage: handler returned invalid contract, skipping`
    );
    return currentFlowData;
  }

  const modifiedFieldsValues = SubmitPreProcessingContract.get(result);

  if (!modifiedFieldsValues) return currentFlowData;

  return {
    ...currentFlowData,
    modifiedFieldsValues: {
      ...(currentFlowData.modifiedFieldsValues || {}),
      ...modifiedFieldsValues,
    },
  };
};

const runSubmitPreProcessingStage = ({ state, form, flowData, onPersistSharedData, onRun }) => {
  const initialState = state.getInitialState();

  return onRun({
    stage: stages.SUBMIT_PRE_PROCESSING,
    initialContext: {
      getFieldsValues: form.getValues,
      state: state.data,
      initialState,
      stateDiff: getStateDifference(initialState, state.data),
      onPersistSharedData,
    },
    flowData,
    onMergeResult: handleMergeResult,
  });
};

export default runSubmitPreProcessingStage;
